module.exports = __webpack_public_path__ + "static/img/search.1eac04d3.png";